@use "src/styles/common/_colors.scss";

/* ----------------------------- TABLE -------------------------------- */
.table {
  width: 100%;
  background-color: colors.$gray-variant;
  margin-bottom: 0px;
  color: colors.$white;
}

.table tbody + tbody {
  border-top: none;
}


.table th.center,
.table td.center {
  text-align: center;
}


.tableWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.stickyHeader {
    thead {
      position: sticky;
      top: 0;
      z-index: 2;
    }
}

